/* am-live-price.js — prețuri și carduri de produs LIVE în articolele de blog.
 *
 * DE CE. Shopify randează `{{ article.content }}` ca HTML brut, fără Liquid, deci
 * un card nu poate fi randat din temă în corpul articolului. Iar prețul scris de
 * mână în text se învechește: măsurat pe 2026-08-18, articolul 001 spunea „1.699
 * lei" pentru Elac DCB41 la ~6 ore după ce prețul live devenise 1.599.
 *
 * CE FACE. Caută în articol două tipare și le completează din endpoint-ul public
 * `/products/<handle>.js`:
 *   <span class="am-price" data-handle="...">de la ~1.600 lei</span>
 *   <div class="am-pcard" data-handle="..."></div>
 *
 * FALLBACK, deliberat: textul dinăuntrul `.am-price` rămâne în HTML și e ce văd
 * crawlerele care NU execută JS (o parte dintre asistenții AI). Îl scriem ca
 * aproximare onestă („de la ~1.600 lei"), niciodată ca preț exact — un preț exact
 * în fallback ar reintroduce exact problema pe care scriptul o rezolvă.
 *
 * Un singur fetch per handle, indiferent de câte ori apare în pagină.
 */
(function () {
  'use strict';
  var cache = {};

  function lei(bani) {
    return (bani / 100).toLocaleString('ro-RO', { maximumFractionDigits: 0 }) + ' lei';
  }

  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    }
    return cache[handle];
  }

  function fillPrice(el, p) {
    if (!p.available) { el.textContent = 'momentan indisponibil'; el.classList.add('am-lp-out'); return; }
    el.textContent = lei(p.price);
    el.classList.add('am-lp-ok');
  }

  function buildCard(el, p) {
    var img = p.featured_image ? String(p.featured_image).replace(/^https?:/, '') : '';
    var url = '/products/' + p.handle;
    var priceHtml = p.available
      ? '<span class="am-pc-price">' + lei(p.price) + '</span>' +
        (p.compare_at_price && p.compare_at_price > p.price
          ? ' <s class="am-pc-was">' + lei(p.compare_at_price) + '</s>' : '')
      : '<span class="am-pc-out">Momentan indisponibil</span>';

    el.innerHTML =
      '<a class="am-pc-link" href="' + url + '">' +
        (img ? '<img class="am-pc-img" src="' + img + '&width=300" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="150" height="150">' : '') +
        '<span class="am-pc-body">' +
          '<span class="am-pc-title">' + (p.title || '') + '</span>' +
          '<span class="am-pc-meta">' + priceHtml + '</span>' +
          '<span class="am-pc-cta">Vezi produsul</span>' +
        '</span>' +
      '</a>';
    el.classList.add('am-pc-ready');
  }

  function run() {
    var prices = document.querySelectorAll('.am-price[data-handle]');
    var cards = document.querySelectorAll('.am-pcard[data-handle]');
    if (!prices.length && !cards.length) return;

    [].forEach.call(prices, function (el) {
      fetchProduct(el.dataset.handle)
        .then(function (p) { fillPrice(el, p); })
        .catch(function () { /* fallback-ul din HTML rămâne vizibil */ });
    });
    [].forEach.call(cards, function (el) {
      fetchProduct(el.dataset.handle)
        .then(function (p) { buildCard(el, p); })
        .catch(function () { el.style.display = 'none'; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
})();
